
import Vue from "vue";
import Component from "vue-class-component";
import { MenuItem } from "../../models/MenuItem";
import { Prop } from "vue-property-decorator";

@Component
export default class ContextMenuButton extends Vue {
  @Prop({ default: [] })
  menuItems: MenuItem[];

  @Prop({ default: null})
  item: any

  itemClicked(menuItem: MenuItem) {
    if(menuItem.action)
      menuItem.action(this.item)

    this.$emit("click", menuItem)
  }

  get validMenuItems() {
    return this.menuItems.filter(x=> x.isValid === undefined || x.isValid(this.item))
  }
}
